import React from 'react';
import { Navigate } from 'react-router-dom';
import { isUserRole, ROLES } from '../../utils/jwt';

const ROLE_HOMES = {
  [ROLES.ADMIN]: '/admin',
  [ROLES.SALESPERSON]: '/salesperson',
  [ROLES.PRODUCTION]: '/produktion',
  [ROLES.CUSTOMER]: '/client',
  [ROLES.PARTNER]: '/partner',
  [ROLES.USER]: '/user',
};

const AdminGuard = ({ children }) => {
  const role = isUserRole();
  if (role !== ROLES.ADMIN) {
    return <Navigate to={ROLE_HOMES[role] || '/auth/sign-in'} />;
  }
  return children;
};

export default AdminGuard;
